import { AllocatePayload, ProviderOption, UserSelfApplyRow } from './types';

export const USER_SELF_APPLY_ALLOCATE = 'USER_SELF_APPLY_ALLOCATE';
export const USER_SELF_APPLY_ALLOCATE_REQUEST = 'USER_SELF_APPLY_ALLOCATE_REQUEST';
export const USER_SELF_APPLY_ALLOCATE_SUCCESS = 'USER_SELF_APPLY_ALLOCATE_SUCCESS';
export const USER_SELF_APPLY_ALLOCATE_FAILURE = 'USER_SELF_APPLY_ALLOCATE_FAILURE';

export const USER_SELF_APPLY_PROVIDERS_REQUEST = 'USER_SELF_APPLY_PROVIDERS_REQUEST';
export const USER_SELF_APPLY_PROVIDERS_SUCCESS = 'USER_SELF_APPLY_PROVIDERS_SUCCESS';
export const USER_SELF_APPLY_PROVIDERS_FAILURE = 'USER_SELF_APPLY_PROVIDERS_FAILURE';

export const allocateUserSelfApplyAction = (payload: AllocatePayload) => ({ type: USER_SELF_APPLY_ALLOCATE, payload });
export const allocateUserSelfApplyRequest = () => ({ type: USER_SELF_APPLY_ALLOCATE_REQUEST });
export const allocateUserSelfApplySuccess = () => ({ type: USER_SELF_APPLY_ALLOCATE_SUCCESS });
export const allocateUserSelfApplyFailure = (error: any) => ({ 
  type: USER_SELF_APPLY_ALLOCATE_FAILURE, payload: error 
});

export const fetchProvidersRequest = () => ({ type: USER_SELF_APPLY_PROVIDERS_REQUEST });
export const fetchProvidersSuccess = (data: ProviderOption[]) => ({ 
  type: USER_SELF_APPLY_PROVIDERS_SUCCESS, payload: data 
});
export const fetchProvidersFailure = (error: any) => ({ type: USER_SELF_APPLY_PROVIDERS_FAILURE, payload: error });


